import { call, put, takeLatest } from "redux-saga/effects";
import { actions } from "./slice";
import * as API from "../../../../../services/apis";

export function* handleFetchOrderDetails({ payload }) {
  try {
    const res = yield call(API.fetchOrderDetails, payload);
    const { data } = res;
    yield put(actions.fetchOrderDetailsSuccess(data));
  } catch (err) {
    yield put(actions.fetchOrderDetailsFailure(err?.response?.data));
  }
}

export function* handleCreateServiceRequest({ payload }) {
  try {
    const res = yield call(API.contactSupport, payload);
    const { data } = res;
    yield put(actions.createServiceRequestSuccess(data));
    payload.onSuccess();
  } catch (err) {
    if (err?.response?.status === 500)
      yield put(
        actions.createServiceRequestFailure({
          message: "Something has gone wrong on the web site's server.",
        })
      );
    else yield put(actions.createServiceRequestFailure(err?.response?.data));
    payload.onFailure();
  }
}

/**
 * Root saga manages watcher lifecycle
 */
export function* serviceRequestSaga() {
  yield takeLatest(actions.fetchOrderDetails.type, handleFetchOrderDetails);
  yield takeLatest(
    actions.createServiceRequest.type,
    handleCreateServiceRequest
  );
}
